import AttendanceLogsService from "@/services/api/AttendenaceLogsReport";
import { handleResponse } from "@/services/axios";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface AttendenaceLogsReportState {
    attendeanceGeofenceReport: any;
    loading: {
        attendanceGeoFenceReport: boolean;
        exportGroup: boolean;
    };
    error: string | null;
}

const initialState: AttendenaceLogsReportState = {
    attendeanceGeofenceReport: null,
    loading: {
        attendanceGeoFenceReport: false,
        exportGroup: false,
    },
    error: null,
};

export const getAttendanceGeoFenceReport = createAsyncThunk(
    "report/getAttendanceGeoFenceReport",
    async (payload: any, { rejectWithValue }) => {
        try {
            const res = await AttendanceLogsService.getAttendanceGeoFenceReport(payload);
            return handleResponse(res, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(err?.response?.data?.message || "Failed to fetch geo fence report");
        }
    }
);

export const getAttendanceLogsReport = createAsyncThunk(
    "report/getAttendanceLogsReport",
    async (payload: any, { rejectWithValue }) => {
        try {            
            const res = await AttendanceLogsService.getAttendanceLogsReport(payload);        
            return saveAsExcelFile(res, "Attendance_GeoFence_Logs");
        } catch (err: any) {
            return rejectWithValue(err?.response?.data?.message || "Failed to export");
        }
    }
);

const attendenaceLogsReportSlice = createSlice({
    name: "attendenaceLogsReport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAttendanceGeoFenceReport.pending, (state) => {
                state.error = null;
                state.loading.attendanceGeoFenceReport = true;
            })
            .addCase(getAttendanceGeoFenceReport.fulfilled, (state, action) => {
                state.error = null;
                state.attendeanceGeofenceReport = action.payload || [];
                state.loading.attendanceGeoFenceReport = false;
            })
            .addCase(getAttendanceGeoFenceReport.rejected, (state, action) => {
                state.error = action.payload as string;
                state.attendeanceGeofenceReport = [];
                state.loading.attendanceGeoFenceReport = false;
            })
            .addCase(getAttendanceLogsReport.pending, (state) => {
                state.error = null;
                state.loading.exportGroup = true;
            })
            .addCase(getAttendanceLogsReport.fulfilled, (state) => {
                state.error = null;
                state.loading.exportGroup = false;
            })
            .addCase(getAttendanceLogsReport.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading.exportGroup = false;
            });
    },
});

export default attendenaceLogsReportSlice.reducer;